module.exports = __webpack_public_path__ + "static/media/joe.0ca07792.jpg";